export default __webpack_public_path__ + "static/media/2.64db8565.jpg";